import React, { useContext, useState } from "react";
import { Dropdown } from "./dynamicMenuDatas/Dropdown";
import { Link, useNavigate } from "react-router-dom";
import ClickOutHandler from "react-clickout-handler";
import { UserContext } from "./Context/UserContext";

export const HeaderMasterDropdown = ({ selectedMenu, setSelectedMenu }) => {
  const { allPermiss } = useContext(UserContext);
  const [isMenuOpen, setIsMenuOpen] = useState(
    Array(Dropdown.length).fill(false)
  );

  const navigate = useNavigate()

  // Handle selecting a main menu item
  const handleMenuClick = (menuItem) => {
    // setSelectedMenu(null)
    setSelectedMenu(menuItem);
    setIsMenuOpen(
      Array(Dropdown.length).fill(false)
    );
  };
  const handleMenuEnterKey = (e, menuItem, path) => {
    if(e.keyCode=== 13){
      navigate(path)
      setSelectedMenu(menuItem);
      setIsMenuOpen(
        Array(Dropdown.length).fill(false)
      );
    }
  };
  function menuOpenCloseHandler(index) {
    const newOpenMenus = isMenuOpen.map((isOpen, i) =>
      i === index ? !isOpen : false
    );
    setIsMenuOpen(newOpenMenus);
  }
  function outClickFun() {
    setIsMenuOpen(Array(Dropdown.length).fill(false));
  }

  return (
    <React.Fragment>
      <ClickOutHandler onClickOut={() => outClickFun()}>
        {Dropdown.map((menu, indexing) => (
          <div key={menu.id} className="inline-block pt-[10px]">
            {/* Dropdown menu */}
            <div className="">
              <ol className="px-1">
                <button
                  className={
                    "font-bold rounded cursor-pointer text-[16px] text-white active:bg-gray-400 hover:bg-red-700 py-0.5 px-2"
                  }
                  onClick={() => menuOpenCloseHandler(indexing)}
                >
                  {menu.label}
                </button>
                <div className="bg-gray-200 min-w-40 rounded absolute z-50 top-8">
                  {isMenuOpen[indexing] &&
                    menu.dropdownMenu.map((item, indexes) => (
                      <>
                        {/* {allPermiss.includes(
                          item.slug_create ||
                            item.slug_view ||
                            item.slug1 ||
                            item.slug2 ||
                            item.slug3 ||
                            item.slug4 ||
                            item.slug5 ||
                            item.slug6 ||
                            item.slug7 ||
                            item.slug8
                        ) && ( */}
                          <Link
                            key={item.id}
                            to={item.path}
                            // onClick={() => menuOpenCloseHandler(indexes)}
                            style={{ textDecoration: "none" }}
                            onKeyDown={(e)=>handleMenuEnterKey(e, item, item.path)}
                          >
                            <li
                              className="py-1 px-3 hover:bg-blue-600 hover:text-white text-black rounded font-medium"
                              onClick={async () => {
                                // setSelectedMenu(null);
                                handleMenuClick(item);
                              }}
                            >
                              <span>
                                {item.label}
                              </span>
                            </li>
                          </Link>
                        {/* )} */}
                      </>
                    ))}
                </div>
              </ol>
            </div>

            {/* Submenu for the selected menu */}

            {/* Close- Submenu*/}
          </div>
        ))}
      </ClickOutHandler>
    </React.Fragment>
  );
};
